import React from 'react';
import App  from 'next/app';
import Router from 'next/router';
import { wrapper } from '~/src/store/createStore';
// import * as Sentry from '@sentry/node';
import 'reset-css';
import 'normalize.css';
import '~/src/assets/css/main.css';
import { connect } from 'react-redux';
import { checkCookie } from '~/src/store/actions/auth';

// const SENTRY_DSN = 'https://4f2fb6adcbf34fcb9b2655cd4395ec95@sentry.ertelecom.ru/8';

/* Sentry.init({
    enabled: process.env.ENVIROMENT === 'production',
    dsn: SENTRY_DSN,
});*/

Router.events.on('routeChangeComplete', () => {
    window.scrollTo(0, 0);
});

class DomruApp extends App {

    timer = null;

    componentDidMount() {
        this.timer = setInterval(this.props.checkCookie, 1000);
    }

    componentWillUnmount() {
        clearInterval(this.timer);
    }

    render() {
        const { Component, pageProps } = this.props;

        return (
            <Component {...pageProps} />
        );
    }
}

function mapStateToProps(state) {
    return {
        isAuth: state.auth.isAuth,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        checkCookie: () => dispatch(checkCookie()),
    };
}

export default wrapper.withRedux(connect(mapStateToProps, mapDispatchToProps)(DomruApp));
